import { render, staticRenderFns } from "./UnconfirmedUsersView.vue?vue&type=template&id=3efce23f&scoped=true&"
import script from "./UnconfirmedUsersView.vue?vue&type=script&lang=js&"
export * from "./UnconfirmedUsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efce23f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VSpacer})
